import React from "react";
import { NavigationLinks, Section } from "../../../../components";
import { Banner, SaibaMais } from "../../sections";
import { ReactComponent as ImageNavigationLinks } from "../../../../assets/images/habitacional/ilustracao-casa-habitacional.svg";

const DuvidasFrequentesPage = () => {
  return (
    <>
      <Banner
        sectionName="Banner da página de dúvidas frequentes"
        descricao="Encontre as principais dúvidas sobre o seu Seguro Habitacional."
      />
      <Section
        as={SaibaMais}
        sectionName="Dúvidas frequentes sobre o seu seguro"
      />
      <Section
        as={NavigationLinks}
        sectionName="Ainda podemos te ajudar?"
        sectionTitle="Ainda podemos te ajudar?"
        image={<ImageNavigationLinks />}
      />
    </>
  );
};

DuvidasFrequentesPage.propTypes = {};

export default DuvidasFrequentesPage;
